import React from 'react';
import { Box, CircularProgress, Typography, Skeleton } from '@mui/material';

const Loading = ({ message = 'Loading...', size = 'medium', inline = false, skeleton = false, count = 3 }) => {
  const spinnerSize = size === 'small' ? 24 : size === 'large' ? 56 : 40;

  if (skeleton) {
    return (
      <Box sx={{ width: '100%' }}>
        {Array.from({ length: count }).map((_, i) => (
          <Skeleton key={i} variant="rectangular" height={60} sx={{ mb: 1, borderRadius: 1 }} />
        ))}
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: inline ? 0 : 6,
        gap: 2,
      }}
    >
      <CircularProgress size={spinnerSize} />
      {message && (
        <Typography variant="body2" color="text.secondary">
          {message}
        </Typography>
      )}
    </Box>
  );
};

export default Loading;
